import React from "react";

export const Logo = ({ variant = "dark", className = "", imgClass = "h-11 w-auto" }) => {
    const src = variant === "light" ? "/brand/logo_negative-400.webp" : "/brand/logo-300.webp";
    return (
        <a href="/#accueil" className={`inline-flex items-center ${className}`} data-testid="logo-home-link">
            <img src={src} alt="Pharmacie La Lutrive — logo" className={imgClass} />
        </a>
    );
};

export default Logo;
